"use client";
import {
  useHovercardStoreProps
} from "./GVVKDT6A.js";
import {
  useStore,
  useStoreProps
} from "./RTNCFSKZ.js";

// src/tooltip/tooltip-store.ts
import * as Core from "@ariakit/core/tooltip/tooltip-store";
function useTooltipStoreProps(store, update, props) {
  useStoreProps(store, props, "type");
  useStoreProps(store, props, "skipTimeout");
  return useHovercardStoreProps(store, update, props);
}
function useTooltipStore(props = {}) {
  const [store, update] = useStore(Core.createTooltipStore, props);
  return useTooltipStoreProps(store, update, props);
}

export {
  useTooltipStoreProps,
  useTooltipStore
};
